<template>
  <div class="wrapper">
    <div class="search-container">
      <!-- <span class="goods-select">商品选择：</span> -->
      <span class="tab-item" :class="tabIndex == index ? 'tab-item-active':''" @click="tabChange(index)"
        v-for="(item, index) in tabs" :key="index">{{item.name}}</span>
    </div>
    <div class="category-container" v-if="tabIndex == 0">
      <span class="category-item" :class="query.sid == item.value ? 'category-item-active':''" @click="categoryChange(item.value)"
        v-for="(item, index) in cateList" :key="index">{{item.label}}</span>
    </div>
    <template v-if="tabIndex == 0">
      <div class="type-select">
        <div class="select-item" @click="selectChange('salesOrder')">
          <span>销量</span>
          <i class="el-icon-sort-down" :class="{'selected': query.salesOrder === 'desc'}" style="width: 10px;"></i>
          <i class="el-icon-sort-up" :class="{'selected': query.salesOrder === 'asc'}"></i>
        </div>
        <div class="select-item" @click="selectChange('priceOrder')">
          <span>价格</span>
          <i class="el-icon-sort-down" :class="{'selected': query.priceOrder === 'desc'}" style="width: 10px;"></i>
          <i class="el-icon-sort-up" :class="{'selected': query.priceOrder === 'asc'}"></i>
        </div>
        <div class="select-item" :class="{'select-item-active': query.news === 1}" @click="selectChange('news')">
          <span>新品</span>
        </div>
        <div class="search-input">
          <el-input placeholder="输入关键字搜索" maxlength="20" v-model="query.keyword" @keyup.enter.native="keywordSearch"
            suffix-icon="el-icon-search" size="medium"></el-input>
        </div>
      </div>
      <div class="goods-list" v-loading="loading">
        <el-row :gutter="30">
          <el-col :span="8" v-for="(goods, index) in list" :key="index">
            <div class="goods-item" @click="toDetail(goods)">
              <div class="goods-item-image">
                <img :src="goods.image" class="imagecover" />
              </div>
              <div class="goods-info">
                <div class="goods-name more-t-2">{{goods.storeName}}</div>
                <div class="goods-about">
                  <span class="goods-price">￥{{goods.price}}</span>
                  <span class="goods-sale">销量：{{goods.ficti > goods.sales ? goods.ficti : goods.sales}}</span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-pagination
          style="text-align: right;"
          background
          layout="prev, pager, next"
          :current-page.sync="page"
          :page-size="size"
          :total="total"
          @current-change="pageChange"
          v-if="total"
        >
        </el-pagination>
      </div>
    </template>
    <RestaList v-else-if="tabIndex == 1" />
    <HotelList v-else-if="tabIndex == 2" />
  </div>
</template>

<script>
import { loadProducts } from '@/api/api'
import HotelList from './components/HotelList.vue'
import RestaList from './components/RestaList.vue'
export default {
  components: {
    HotelList,
    RestaList
  },
  data() {
    return {
      tabIndex: 0,
      tabs: [
        {
          name: '商城'
        },
        {
          name: '订餐'
        },
        {
          name: '订房'
        }
      ],
      query: {
        keyword: '',
        priceOrder: '',
        salesOrder: '',
        news: 0,
        sid: ''
      },
      selectActive: 0,
      selectItems: [
        {
          name: '价格',
          type: 'salesOrder'
        },
        {
          name: '销量',
          type: 'priceOrder'
        },
        {
          name: '新品',
          type: 'news'
        }
      ],
      list: [],
      cateList: [
        {
          disabled: 1,
          label: '全部',
          value: ''
        }
      ],
      page: 1,
      size: 10,
      loading: false,
      total: 0
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    pageChange(val) {
      this.page = val
      this.loadData()
    },
    keywordSearch() {
      this.page = 1
      this.loadData()
    },
    loadData() {
      var params = Object.assign({
        page: this.page,
        limit: this.size
      }, this.query)
      this.loading = true
      
      loadProducts(params).then(res => {
        this.loading = false
        this.total = res.totalElements
        this.list = res.data
        if(this.cateList.length <= 1) {
          let cateList = (res.cateList || []).map((item) => {
            item.label = item.label.replaceAll('|-----', '');
            return item;
          }).filter((item) => {
            return item.disabled;
          })
          this.cateList = this.cateList.concat(cateList);
        }
      }).catch(err => {
        this.loading = false
      })
    },
    tabChange(index) {
      this.tabIndex = index
    },
    categoryChange(value) {
      this.query.sid = value;
      this.page = 1;
      this.loadData();
    },
    selectChange(index) {
      if(index === 'news') {
        this.query.news = this.query.news === 0 ? 1 : 0
      } else if(index === 'salesOrder') {
        this.query.priceOrder = ''
        switch(this.query.salesOrder) {
          case 'asc': this.query.salesOrder = 'desc'; break;
          case 'desc': this.query.salesOrder = ''; break;
          case '': this.query.salesOrder = 'asc';break;
          default: this.query.salesOrder = ''; break;
        }
      } else if(index === 'priceOrder') {
        this.query.salesOrder = ''
        switch(this.query.priceOrder) {
          case 'asc': this.query.priceOrder = 'desc'; break;
          case 'desc': this.query.priceOrder = ''; break;
          case '': this.query.priceOrder = 'asc';break;
          default: this.query.priceOrder = ''; break;
        }
      }
      this.page = 1
      this.loadData()
    },
    toDetail(item) {
      this.$router.push({
        path: '/shop/detail/' + item.id
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/styles/color.scss';
  .wrapper {
    padding: 20px 0 0;
    width: 1200px;
    margin: 0 auto;
  }
  .search-container {
    display: flex;
    align-items: center;
    .goods-select {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
    .tab-item {
      padding: 0 9px;
      height: 26px;
      line-height: 26px;
      border-radius: 4px;
      text-align: center;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      cursor: pointer;
      margin-right: 20px;
      &.tab-item-active {
        color: #FFFFFF;
        background: $primary-color;
      }
    }
    .search-input {
      margin-left: auto;
    }
  }
  .category-container {
    padding: 10px 0;
    .category-item {
      display: inline-block;
      padding: 0 9px;
      height: 26px;
      line-height: 26px;
      border-radius: 4px;
      text-align: center;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      cursor: pointer;
      margin-right: 20px;
      &.category-item-active {
        color: #FFFFFF;
        background: $primary-color;
      }
    }
  }
  .type-select {
    padding: 20px 0;
    .select-item {
      display: inline-block;
      line-height: 40px;
      margin-right: 60px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      cursor: pointer;
      &.select-item-active {
        color: $primary-color;
      }
      .selected {
        color: $primary-color;
      }
    }
    .search-input {
      float: right;
    }
  }
  .goods-list {
    padding-bottom: 50px;
    .goods-item {
      width: 100%;
      background: #FFFFFF;
      box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);
      cursor: pointer;
      margin-bottom: 30px;
      .goods-item-image {
        width: 100%;
        height: 400px;
      }
      .goods-info {
        padding: 10px;
        .goods-name {
          width: 100%;
          height: 48px;
          line-height: 24px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
        }
        .goods-about {
          display: flex;
          justify-content: space-between;
          line-height: 30px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          .goods-price {
            font-weight: bold;
            color: #FF6C0B;
          }
          .goods-sale {
            font-weight: 400;
            color: #999999;
          }
        }
      }
    }
  }
</style>